import { ProFormInstance } from '@ant-design/pro-form';
import { atom } from 'jotai';
import { useRef } from 'react';
import { ActionType } from '@ant-design/pro-components';
import { atomWithHash } from 'jotai-location';
import { atomWithQuery, atomWithSuspenseQuery } from 'jotai-tanstack-query';
import axiosApiInstance from '../../../api/axiosClient';

export type entriesAtomType = {
    album_name: string;
    upc: string;
    label_id: number;
    main_artist_id: number;
    number_of_tracks: number;
    initial_track_array: Array<any>;
};

export const releaseEntriesAtom = atom<entriesAtomType>({
    album_name: '',
    upc: '',
    label_id: 1,
    main_artist_id: 1,
    number_of_tracks: 1,
    initial_track_array: Array(1)
});

// const formRef = useRef<ProFormInstance<entriesAtomType>>(null);

export const formRefAtom = atom((read) => useRef<ProFormInstance<any>>());

export const labelOptions = [
    {
        label: 'Panik Records',
        value: 1
    },
    {
        label: 'MelodyMaker',
        value: 2
    }
];

export const artistOptions = [
    {
        label: 'Snik',
        value: 1
    },
    {
        label: 'Lefteris Pantazis',
        value: 2
    },
    {
        label: 'Josephine',
        value: 3
    }
];

type defaultSelections = {
    main_artists: string[];
    featuring_artists?: string[];
};

export const defaultSelectionsAtom = atom<defaultSelections>({
    main_artists: []
});

// atom with the action ref of the releases table
export const releasesActionRefAtom = atom((read) => useRef<ActionType>());

export const artistsActionRefAtom = atom((read) => useRef<ActionType>());

export const labelsActionRefAtom = atom((read) => useRef<ActionType>());

export const assetLabelsActionRefAtom = atom((read) => useRef<ActionType>());

export const releasesViewAtom = atomWithHash<string | undefined>('releasesView', 'verified');
export const draftsViewAtom = atomWithHash<string | undefined>('draftsView', 'pending');

export const assetLabelsAtom = atomWithQuery<API.MusicDistribution.AssetLabel[]>((get) => ({
    queryKey: ['asset_labels'],
    queryFn: async () => {
        const response = await axiosApiInstance.get(`/api/products/asset_labels/`);
        // console.log(response.data);
        return response.data;
    }
}));

export const labelsAtom = atomWithQuery<API.MusicDistribution.Label[]>((get) => ({
    queryKey: ['labels'],
    queryFn: async () => {
        const response = await axiosApiInstance.get(`/api/products/labels/`);
        // console.log(response.data);
        return response.data;
    }
}));

export const newReleaseUploadQueueAtom = atom<{
    cover_art: Function;
    art_tracks: Function[];
}>({
    cover_art: () => {
    }, art_tracks: []
});

export const artistsAtom = atomWithQuery<API.MusicDistribution.Artist[]>((get) => ({
    queryKey: ['artists'],
    queryFn: async () => {
        const response = await axiosApiInstance.get<API.MusicDistribution.Artist[]>(`/api/products/artists/`);
        return response.data;
    }
}));

export const artistOptionsAtom = atom((get) => {
    const artistsQuery = get(artistsAtom);
    // Assuming artistsQuery.data is an array of artists
    if (artistsQuery.isLoading || artistsQuery.isError || !artistsQuery.data) {
        return [];
    }
    // Adjust artist.artist_name and artist.artist_id if the actual properties are different
    return artistsQuery.data.map((artist: any) => ({
        label: artist.key_name, // Or the correct property for name
        value: artist.key_name    // Or the correct property for id
    }));
});

// Atom to store validation warnings for the release form
export const warningsAtom = atom<{ field: string, message: string, group: string }[]>([]);

export const isReleaseInfoLoadingAtom = atom<boolean>(false);

// Atom to store confirmation modal state
export type ConfirmationModalState = {
    visible: boolean;
    upcCount: number;
    isrcCount: number;
    previewUPC: string;
    previewISRCs: Record<string, string>;
    validationWarnings: { field: string, message: string, group: string }[];
};

export const confirmationModalAtom = atom<ConfirmationModalState>({
    visible: false,
    upcCount: 0,
    isrcCount: 0,
    previewUPC: '',
    previewISRCs: {},
    validationWarnings: []
});


export const groupIdentifiersTotalAtom = atom<number>(0);
export const selectedGroupReleasesTotalAtom = atom<number>(0);